// extracted by mini-css-extract-plugin
module.exports = {"menuwrap":"navigation-module--menuwrap--2hlgQ","toggler":"navigation-module--toggler--1HNw4","hamburger":"navigation-module--hamburger--2NxAo"};